import { NgModule, Directive, ElementRef } from "@angular/core";

/**
 * The input label text element
 */
@Directive({
  selector: "ui-input-label",
})
export class InputLabelDirective {
  constructor(public elementRef: ElementRef<HTMLElement>) {}
}

/**
 * The input helper text element
 */
@Directive({
  selector: "ui-input-hint",
})
export class InputHintDirective {
  constructor(public elementRef: ElementRef<HTMLElement>) {}
}

/**
 * The input validation error text element
 */
@Directive({
  selector: "ui-input-message",
})
export class InputMessageDirective {
  constructor(public elementRef: ElementRef<HTMLElement>) {}
}

/**
 * The `InputsModule` contains utilities for input components.
 */
@NgModule({
  declarations: [InputLabelDirective, InputHintDirective, InputMessageDirective],
  exports: [InputLabelDirective, InputHintDirective, InputMessageDirective],
})
export class InputsModule {}
